import { UPDATE_WHATSAPP_NDR_VERIFICATION_CHARGES_REQUEST, UPDATE_WHATSAPP_NDR_VERIFICATION_CHARGES_SUCCESS, UPDATE_WHATSAPP_NDR_VERIFICATION_CHARGES_FAILURE, } from "@/redux/actions";
const initialState = {
    data: null,
    loading: false,
    error: null,
};
const updateWhatsappNdrVerificationChargesReducer = (state = initialState, action) => {
    switch (action.type) {
        case UPDATE_WHATSAPP_NDR_VERIFICATION_CHARGES_REQUEST:
            return Object.assign(Object.assign({}, state), { loading: true, error: null });
        case UPDATE_WHATSAPP_NDR_VERIFICATION_CHARGES_SUCCESS:
            return Object.assign(Object.assign({}, state), { loading: false, data: action.payload, error: null });
        case UPDATE_WHATSAPP_NDR_VERIFICATION_CHARGES_FAILURE:
            return Object.assign(Object.assign({}, state), { loading: false, error: action.payload });
        default:
            return state;
    }
};
export default updateWhatsappNdrVerificationChargesReducer;
